import React from 'react';
import '../Public/css/loading.css'

function loading() {
    return (
        <div className="loader">
            <div className="inner one"></div>
            <div className="inner two"></div>
            <div className="inner three"></div>
        </div>
    )
}

export default loading;
